import api from './api';

const adminPartnerService = {
  // User Management

  // Get all users with filters
  getAllUsers: async (params = {}) => {
    const response = await api.get('/auth/admin/users/', { params });
    return response.data;
  },

  // Get user by ID
  getUserById: async (id) => {
    const response = await api.get(`/auth/admin/users/${id}/`);
    return response.data;
  },

  // Update user (for segment, is_active, etc.)
  updateUser: async (id, data) => {
    const response = await api.patch(`/auth/admin/users/${id}/update/`, data);
    return response.data;
  },

  // Promote user to partner
  promoteToPartner: async (userId, data) => {
    try {
      const response = await api.post(`/partners/promote/`, {
        user_id: userId,
        ...data
      });
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.response?.data?.detail || 'Failed to promote user';
      throw new Error(errorMessage);
    }
  },

  // Deactivate user
  deactivateUser: async (userId) => {
    const response = await api.post(`/auth/admin/users/${userId}/deactivate/`);
    return response.data;
  },

  // Reactivate user
  reactivateUser: async (userId) => {
    const response = await api.post(`/auth/admin/users/${userId}/reactivate/`);
    return response.data;
  },

  // Downgrade partner to client
  downgradePartner: async (userId) => {
    const response = await api.post(`/auth/admin/users/${userId}/downgrade/`);
    return response.data;
  },

  // Delete user permanently
  deleteUser: async (userId) => {
    const response = await api.delete(`/auth/admin/users/${userId}/delete/`);
    return response.data;
  },

  // Impersonate user (switch to user account)
  impersonateUser: async (userId) => {
    const response = await api.post(`/auth/admin/users/${userId}/impersonate/`);
    return response.data;
  },

  // Partner Management

  // Get all partners with filters
  getAllPartners: async (params = {}) => {
    const response = await api.get('/partners/admin/', { params });
    return response.data;
  },

  // Get partner by ID
  getPartnerById: async (id) => {
    const response = await api.get(`/partners/admin/${id}/`);
    return response.data;
  },

  // Update partner
  updatePartner: async (id, data, isFormData = false) => {
    const config = isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const response = await api.patch(`/partners/admin/${id}/update/`, data, config);
    return response.data;
  },

  // Bundle Request Management

  // Get all bundle requests
  getAllBundleRequests: async (params = {}) => {
    const response = await api.get('/partners/admin/bundles/', { params });
    return response.data;
  },

  // Get pending bundle requests
  getPendingBundleRequests: async () => {
    const response = await api.get('/partners/admin/bundles/pending/');
    return response.data;
  },

  // Get bundle request by ID
  getBundleRequestById: async (id) => {
    const response = await api.get(`/partners/admin/bundles/${id}/`);
    return response.data;
  },

  // Approve bundle request
  approveBundleRequest: async (id, notes = '') => {
    const response = await api.post(`/partners/admin/bundles/${id}/`, {
      action: 'approve',
      notes
    });
    return response.data;
  },

  // Reject bundle request
  rejectBundleRequest: async (id, notes = '') => {
    const response = await api.post(`/partners/admin/bundles/${id}/`, {
      action: 'reject',
      notes
    });
    return response.data;
  }
};

export default adminPartnerService;
